import { ITeacherFilters } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import { create as createStore } from 'zustand';

import { sdk } from '@/services';

const INITIAL_PAGE = 1;
const INITIAL_LIMIT = 50;

const MyAcademyTeachersService = sdk.getService('MyAcademyTeachersService');

interface IStore {
  page: number;
  limit: number;
  search: string;
  filter?: ITeacherFilters;
  setSearch: (search: string) => void;
  setPageAndLimit: (page: number, limit: number) => void;
  setFilter: (filter?: ITeacherFilters) => void;
}

const store = createStore<IStore>(set => ({
  page: INITIAL_PAGE,
  limit: INITIAL_LIMIT,
  search: '',
  setSearch: (search: string) => set(state => ({ ...state, search, page: INITIAL_PAGE })),
  setFilter: (filter?: ITeacherFilters) => set(state => ({ ...state, page: INITIAL_PAGE, filter })),
  setPageAndLimit: (page: number, limit: number) => set(state => ({ ...state, page, limit }))
}));

export const useTeachersAndManagersList = (fetchAll = false) => {
  const { page, limit, search, filter, setFilter, setSearch, setPageAndLimit } = store();

  const queryKey = [
    'teachers-and-managers',
    `page-${page}`,
    `limit-${limit}`,
    search,
    `bypass-${fetchAll}`,
    filter
  ];
  const { isLoading, data, error } = useQuery({
    queryKey,
    queryFn: () =>
      MyAcademyTeachersService.getTeachersAndManagers(search, { page, limit }, filter, fetchAll)
  });

  const resetSearchResults = () => setSearch('');

  const pagination = data && {
    page: data.page,
    limit: data.limit,
    hasNextPage: data.hasNextPage,
    hasPrevPage: data.hasPrevPage,
    nextPage: data.nextPage,
    pagingCounter: data.pagingCounter,
    prevPage: data.prevPage,
    totalDocs: data.totalDocs,
    totalPages: data.totalPages
  };

  return {
    teachersAndManagers: data?.docs,
    isLoading,
    error,
    filter,
    setFilter,
    setPageAndLimit,
    pagination,
    setSearch,
    resetSearchResults
  };
};
